// Pricing data, shared by the 4 pricing routes. `promo` variants show the
// "Save 50% on your first two months" treatment; plain variants show full price.
//
// The tiers/features are the single source of truth in pricing.json, also read
// server-side by Marketing::Pricing (structured data + the /pricing-and-features.md
// agent view) so every surface stays in sync from one place.
import pricingData from './pricing.json';

const FEATURES = pricingData.features;
const TIERS = pricingData.tiers;

export const PRICING_VARIANTS = {
  'pricing-and-features': { promo: false, features: FEATURES, tiers: TIERS },
  'pricing-features-africa': { promo: false, features: FEATURES, tiers: TIERS },
  'pricing-no-promo': { promo: false, features: FEATURES, tiers: TIERS },
  'pricing-old': { promo: false, features: FEATURES, tiers: TIERS },
};

export const DEFAULT_VARIANT = 'pricing-and-features';
